import { createContext, useContext, useMemo } from 'react';
import React, { type ReactNode } from 'react';

import { FolderType } from '@/api/generated';

type LocationContextValue = {
  organizationSlug?: string;
  locationSlug?: string;
  locationType?: FolderType;
};

const LocationContext = createContext<LocationContextValue>({});

type LocationProviderProps = LocationContextValue & {
  children: ReactNode;
};

export const LocationProvider = ({ organizationSlug, locationSlug, locationType, children }: LocationProviderProps) => {
  const value = useMemo(
    () => ({
      organizationSlug,
      locationSlug,
      locationType
    }),
    [organizationSlug, locationSlug, locationType]
  );

  return <LocationContext.Provider value={value}>{children}</LocationContext.Provider>;
};

export const useLocation = () => useContext(LocationContext);
